/**
 * Iter XX.267 — Gully Pro Pricing Anchor + Waitlist.
 *
 * Small helpers used by <ProTierCard /> and <ProWaitlistSheet />.
 *
 * Never touches billing / entitlements. All calls are fire-and-forget:
 * a failure never blocks the UX.
 */
import api from "./api";

const PRO_PRICE_LABEL = "$99";
const PRO_PRICE_PERIOD = "month";
const PRO_STATED_PRICE_POINT = 99;

/**
 * Send an additive analytics event to the existing /plus/track endpoint.
 * All XX.267 event names are additive; we never rename existing events.
 *
 * @param {string} kind   e.g. "pro_plan_viewed", "pro_waitlist_clicked"
 * @param {string} source e.g. "upgrade_page", "paywall_modal"
 * @param {string=} sessionId
 * @param {object=} payload  optional structured payload
 */
export function trackProEvent(kind, source, sessionId, payload) {
  if (!kind) return;
  try {
    api
      .post("/plus/track", {
        kind,
        session_id: sessionId || null,
        source: source || null,
        payload: payload || null,
      })
      .catch(() => {});
  } catch { /* swallow */ }
}

/**
 * Join the Gully Pro waitlist. Upserts server-side by user_id when
 * authenticated, else by session_id, else by entry_id — repeat taps
 * never create dupes.
 *
 * @param {object} opts
 * @param {string=} opts.source
 * @param {string=} opts.sessionId
 * @param {string=} opts.email
 * @param {string=} opts.entryId       returned by a prior call — links follow-ups
 * @param {"yes"|"maybe"|"no"|null=} opts.intentResponse
 * @returns {Promise<{ok:boolean, joined:boolean, intent_recorded:boolean, entry_id?:string}>}
 */
export async function joinProWaitlist({
  source, sessionId, email, entryId, intentResponse,
} = {}) {
  try {
    const { data } = await api.post("/pro/waitlist", {
      session_id: sessionId || null,
      email: email || null,
      source: source || null,
      entry_id: entryId || null,
      intent_response: intentResponse || null,
    });
    return data || { ok: false, joined: false, intent_recorded: false };
  } catch {
    return { ok: false, joined: false, intent_recorded: false };
  }
}

export const PRO_META = {
  priceLabel: PRO_PRICE_LABEL,
  period: PRO_PRICE_PERIOD,
  statedPricePoint: PRO_STATED_PRICE_POINT,
};
